import { NotificationType } from '../models/Notification';
import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class SendNotificationUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(
    userId: string,
    type: NotificationType,
    title: string,
    body: string,
    data?: Record<string, string>
  ): Promise<void> {
    logger.debug('SendNotification', 'Sending notification', { userId, type });
    await this.notificationRepository.sendNotification(userId, type, title, body, data);
    logger.debug('SendNotification', 'Notification sent successfully');
  }
}
